/* boebody size calculator — in-house replacement for the old iframe widget (Dana AI).
   Data comes from the product's boebody.size_calc metafield, rendered into the page by
   snippets/size-calc.liquid. All calculation happens here in the browser; no external server.
   The size tables' source of truth is the product's size-chart Page; a daily cloud job
   re-parses those pages into the metafield. */
(function () {
  "use strict";

  var SIZE_ORDER = ["XS", "S", "M", "L", "XL", "XXL"];
  // The full cup ladder we always offer her. boebody's printed tables mostly stop at D, so the
  // daily sync learns each table's own logic and fills E-G into the metafield (fit-cups.js).
  // resolveCup below stays as a safety net for any table that still lacks a column.
  var CUPS_ALL = ["A", "B", "C", "D", "E", "F", "G"];
  var COLOR_HE = {
    "beige": "בז'", "black": "שחור", "white": "לבן", "brown": "חום",
    "mocha": "מוקה", "dark mocha": "מוקה כהה", "chocolate brown": "חום שוקולד",
    "powder pink": "ורוד פודרה", "pink": "ורוד", "purple": "סגול", "tan": "טאן",
    "very dark brown": "חום כהה"
  };

  function heColor(c) {
    if (!c) return "";
    return COLOR_HE[String(c).trim().toLowerCase()] || c;
  }

  function el(tag, cls, text) {
    var e = document.createElement(tag);
    if (cls) e.className = cls;
    if (text) e.textContent = text;
    return e;
  }

  function getData(root) {
    var s = root.querySelector("script[data-boe-sc-json]");
    if (!s) return null;
    try { return JSON.parse(s.textContent); } catch (e) { return null; }
  }

  function hipsToPants(cm, conv) {
    for (var i = 0; i < conv.length; i++) if (cm <= conv[i].maxCm) return conv[i].pants;
    return conv[conv.length - 1].pants;
  }

  function biggerSize(a, b) {
    return SIZE_ORDER.indexOf(a) >= SIZE_ORDER.indexOf(b) ? a : b;
  }

  // -> { size, note } לפי טבלת תחתונים (מידת מכנסיים)
  function calcBottoms(table, pants) {
    var hit = null, minStart = null, maxEnd = null, minSize = null, maxSize = null;
    table.pants.forEach(function (r) {
      if (minStart === null || r.min < minStart) { minStart = r.min; minSize = r.size; }
      if (maxEnd === null || r.max > maxEnd) { maxEnd = r.max; maxSize = r.size; }
      if (pants >= r.min && pants <= r.max) hit = hit ? biggerSize(hit, r.size) : r.size;
    });
    if (hit) return { size: hit, note: null };
    if (pants < minStart) return { size: minSize, note: "small" };
    return { size: maxSize, note: "big" };
  }

  // היקף חזה פחות היקף מתחת לחזה -> קאפ, לפי הסקאלה הבינלאומית (כל 2.5 ס"מ = אות)
  function deriveCup(bust, under) {
    var d = bust - under;
    if (d < 11.25) return "A";
    if (d < 13.75) return "B";
    if (d < 16.25) return "C";
    if (d < 18.75) return "D";
    if (d < 21.25) return "E";
    if (d < 23.75) return "F";
    return "G";
  }

  // הקאפ שהיא בחרה מול העמודות שקיימות בטבלה של הפריט
  function resolveCup(cup, tableCups) {
    if (tableCups.indexOf(cup) >= 0) return { cup: cup, clampedFrom: null };
    var present = CUPS_ALL.filter(function (c) { return tableCups.indexOf(c) >= 0; });
    if (!present.length) return { cup: tableCups[0], clampedFrom: null };
    var idx = CUPS_ALL.indexOf(cup);
    var smallest = present[0], biggest = present[present.length - 1];
    if (idx > CUPS_ALL.indexOf(biggest)) return { cup: biggest, clampedFrom: cup };
    if (idx < CUPS_ALL.indexOf(smallest)) return { cup: smallest, clampedFrom: cup };
    var best = present[0];
    present.forEach(function (c) {
      if (Math.abs(CUPS_ALL.indexOf(c) - idx) < Math.abs(CUPS_ALL.indexOf(best) - idx)) best = c;
    });
    return { cup: best, clampedFrom: cup };
  }

  function calcTop(table, under, cup) {
    var rows = table.rows.slice().sort(function (a, b) { return a.cm - b.cm; });
    var row = rows[0];
    for (var i = 0; i < rows.length; i++) if (rows[i].cm <= under) row = rows[i];
    var size = row.sizes[cup];
    // רשת ביטחון לתא ריק בשורה. בלי זה clampToProduct קיבל undefined והחזיר את המידה הקטנה
    // ביותר בפריט, כלומר קאפ גדול היה מקבל XS. קודם מנסים קאפ גדול יותר, כי קטן מדי זו הטעות היקרה.
    if (!size) {
      var idx = CUPS_ALL.indexOf(cup);
      for (var j = idx + 1; j < CUPS_ALL.length && !size; j++) size = row.sizes[CUPS_ALL[j]];
      for (var m = idx - 1; m >= 0 && !size; m--) size = row.sizes[CUPS_ALL[m]];
    }
    return { size: size, note: null };
  }

  // ---- טבלת גובה כפול היקף ירכיים (גרביונים) ----
  // 18/10/2026: עד היום הסוג הזה נקרא top_matrix והמחשבון שאל את הלקוחה מה הקאפ
  // שלה בגרביון. השורות בטבלה המודפסת הן גובה והעמודות הן היקף ירכיים, ולא
  // מתחת-לחזה וקאפ. אי אפשר גם לקרוס את הטבלה להיקף בלבד: באותו היקף ירכיים
  // 96-99 אישה בגובה 150 מקבלת S ובגובה 178 מקבלת L. שתי מידות הפרש.
  function calcHeightHips(table, height, hips) {
    var cols = table.hips || [], rows = table.rows || [];
    if (!cols.length || !rows.length) return null;

    var colIdx = -1, note = null;
    for (var i = 0; i < cols.length; i++) {
      if (hips >= cols[i].min && hips <= cols[i].max) { colIdx = i; break; }
    }
    if (colIdx < 0) {
      if (hips < cols[0].min) { colIdx = 0; note = "small"; }
      else if (hips > cols[cols.length - 1].max) { colIdx = cols.length - 1; note = "big"; }
      else {
        // נפל בחור בין שתי עמודות בטבלה המודפסת. עולים לעמודה הרחבה יותר,
        // כי מידה גדולה מדי מחליפים בקלות וקטנה מדי לא.
        for (var g = 0; g < cols.length; g++) { if (cols[g].min > hips) { colIdx = g; break; } }
        if (colIdx < 0) colIdx = cols.length - 1;
      }
    }
    var key = cols[colIdx].key;

    var sorted = rows.slice().sort(function (a, b) { return b.maxCm - a.maxCm; });
    var row = null;
    for (var j = 0; j < sorted.length; j++) {
      if (height >= sorted[j].minCm && height <= sorted[j].maxCm) { row = sorted[j]; break; }
    }
    if (!row) {
      if (height > sorted[0].maxCm) row = sorted[0];
      else if (height < sorted[sorted.length - 1].minCm) row = sorted[sorted.length - 1];
      else {
        for (var k = sorted.length - 1; k >= 0; k--) { if (sorted[k].minCm > height) { row = sorted[k]; break; } }
        if (!row) row = sorted[0];
      }
    }
    var size = row.sizes[key];
    return size ? { size: size, note: note } : null;
  }

  // אם הטבלה ממליצה מידה שלא קיימת בפריט (למשל XS בפריט שמתחיל ב-S)
  function clampToProduct(size, sizesAll) {
    if (sizesAll.indexOf(size) >= 0) return { size: size, clampedFrom: null };
    var idx = SIZE_ORDER.indexOf(size);
    var existing = SIZE_ORDER.filter(function (s) { return sizesAll.indexOf(s) >= 0; });
    if (!existing.length) return { size: size, clampedFrom: null };
    var smallest = existing[0], biggest = existing[existing.length - 1];
    if (idx < SIZE_ORDER.indexOf(smallest)) return { size: smallest, clampedFrom: size };
    if (idx > SIZE_ORDER.indexOf(biggest)) return { size: biggest, clampedFrom: size };
    var best = existing[0];
    existing.forEach(function (s) {
      if (Math.abs(SIZE_ORDER.indexOf(s) - idx) < Math.abs(SIZE_ORDER.indexOf(best) - idx)) best = s;
    });
    return { size: best, clampedFrom: size };
  }

  function buildForm(root, data) {
    var body = root.querySelector("[data-boe-sc-body]");
    body.innerHTML = "";
    var t = data.texts;

    function numInput(ph) {
      var i = el("input", "boe-sc-input");
      i.type = "text"; i.inputMode = "numeric"; i.placeholder = ph; i.setAttribute("aria-label", ph);
      return i;
    }

    var fields = {};
    if (data.table.type === "bottoms") {
      fields.hips = numInput(t.hips);
      var orEl = el("div", "boe-sc-or", t.or);
      var pantsSel = el("select", "boe-sc-input boe-sc-select");
      pantsSel.setAttribute("aria-label", t.pants);
      pantsSel.appendChild(new Option(t.pants, ""));
      var minP = 99, maxP = 0;
      data.table.pants.forEach(function (r) { if (r.min < minP) minP = r.min; if (r.max > maxP) maxP = r.max; });
      if (minP % 2) minP -= 1;
      for (var p = minP; p <= maxP; p += 2) pantsSel.appendChild(new Option(String(p), String(p)));
      fields.pants = pantsSel;
      body.appendChild(fields.hips); body.appendChild(orEl); body.appendChild(pantsSel);
    } else if (data.table.type === "height_hips") {
      // גרביונים: גובה והיקף ירכיים. בלי קאפ, בלי מתחת לחזה.
      fields.height = numInput(t.height);
      fields.hips = numInput(t.hips);
      body.appendChild(fields.height); body.appendChild(fields.hips);
    } else {
      fields.under = numInput(t.under);
      var cupSel = el("select", "boe-sc-input boe-sc-select");
      cupSel.setAttribute("aria-label", t.cup);
      cupSel.appendChild(new Option(t.cup, ""));
      CUPS_ALL.forEach(function (c) { cupSel.appendChild(new Option(c, c)); });
      fields.cup = cupSel;
      body.appendChild(fields.under); body.appendChild(cupSel);
      var noCup = el("button", "boe-sc-link", t.noCup);
      noCup.type = "button";
      var bust = numInput(t.bust);
      bust.style.display = "none";
      noCup.addEventListener("click", function () {
        bust.style.display = bust.style.display === "none" ? "" : "none";
        if (bust.style.display === "") bust.focus();
      });
      fields.bust = bust;
      body.appendChild(noCup); body.appendChild(bust);
      // גובה: רק בטופים. שתי המדידות האמיתיות הראשונות (06/08/2026) היו נשים גבוהות מאוד
      // שקיבלו M ולקחו L. בטופ סימלס אין תפרים שמחלקים אורך, אז גוף ארוך מותח לאורך ומצר ברוחב.
      var tallWrap = el("label", "boe-sc-check");
      var tallBox = document.createElement("input");
      tallBox.type = "checkbox";
      tallWrap.appendChild(tallBox);
      tallWrap.appendChild(el("span", null, t.tall));
      fields.tall = tallBox;
      body.appendChild(tallWrap);
    }

    var err = el("div", "boe-sc-error", "");
    err.style.display = "none";
    var result = el("div", "boe-sc-result", "");
    result.style.display = "none";
    result.setAttribute("aria-live", "polite");

    var calcBtn = el("button", "boe-sc-btn", t.calc);
    calcBtn.type = "button";
    var retryBtn = el("button", "boe-sc-link boe-sc-retry", t.retry);
    retryBtn.type = "button"; retryBtn.style.display = "none";

    calcBtn.addEventListener("click", function () {
      err.style.display = "none";
      var res = null, cupClampedFrom = null;
      if (data.table.type === "bottoms") {
        var pantsVal = parseInt(fields.pants.value, 10);
        var hipsVal = parseFloat((fields.hips.value || "").replace(",", "."));
        if (!pantsVal && !(hipsVal > 0)) { err.textContent = t.fill; err.style.display = ""; return; }
        var pants = pantsVal || hipsToPants(hipsVal, data.conv);
        res = calcBottoms(data.table, pants);
      } else if (data.table.type === "height_hips") {
        var hVal = parseFloat((fields.height.value || "").replace(",", "."));
        var hipVal = parseFloat((fields.hips.value || "").replace(",", "."));
        if (!(hVal > 0) || !(hipVal > 0)) { err.textContent = t.fillHH; err.style.display = ""; return; }
        res = calcHeightHips(data.table, hVal, hipVal);
      } else {
        var underVal = parseFloat((fields.under.value || "").replace(",", "."));
        if (!(underVal > 0)) { err.textContent = t.fill; err.style.display = ""; return; }
        var cup = fields.cup.value;
        var bustVal = parseFloat((fields.bust.value || "").replace(",", "."));
        if (!cup) {
          if (!(bustVal > underVal)) { err.textContent = t.fillCup; err.style.display = ""; return; }
          cup = deriveCup(bustVal, underVal);
        }
        var resolved = resolveCup(cup, data.table.cups);
        cupClampedFrom = resolved.clampedFrom;
        res = calcTop(data.table, underVal, resolved.cup);
      }
      if (!res || !res.size) { err.textContent = t.fill; err.style.display = ""; return; }

      // תקרת הגובה: XL הוא הגבול. מי שהטבלה נתנה לה XL לא תקפוץ ל-XXL בגלל הגובה
      // (הכרעת דליה 06/08/2026). בקצה הזה הבגד ממילא נדיב, והקפיצה הזו גדולה מדי.
      var TALL_MAX = SIZE_ORDER.indexOf("XL");
      var tallFrom = null;
      if (fields.tall && fields.tall.checked) {
        var ti = SIZE_ORDER.indexOf(res.size);
        if (ti >= 0 && ti + 1 <= TALL_MAX) { tallFrom = res.size; res = { size: SIZE_ORDER[ti + 1], note: res.note }; }
      }

      var clamped = clampToProduct(res.size, data.sizesAll);
      var lines = [];
      var main = t.resPrefix + data.title + ": " + clamped.size + " 🤍";
      lines.push("<div class=\"boe-sc-size\">" + main + "</div>");
      if (tallFrom) lines.push("<div class=\"boe-sc-note\">" + t.tallNote.replace("{rec}", tallFrom) + "</div>");
      if (clamped.clampedFrom) {
        var note = SIZE_ORDER.indexOf(clamped.clampedFrom) < SIZE_ORDER.indexOf(clamped.size) ? t.clampSmall : t.clampBig;
        lines.push("<div class=\"boe-sc-note\">" + note.replace("{rec}", clamped.clampedFrom).replace("{size}", clamped.size) + "</div>");
      } else if (res.note === "small") {
        lines.push("<div class=\"boe-sc-note\">" + t.rangeSmall + "</div>");
      } else if (res.note === "big") {
        lines.push("<div class=\"boe-sc-note\">" + t.rangeBig + "</div>");
      }
      if (cupClampedFrom) {
        var widest = data.table.cups[data.table.cups.length - 1];
        lines.push("<div class=\"boe-sc-note\">" + t.cupClamp.replace("{cup}", cupClampedFrom).replace("{max}", widest) + "</div>");
      }
      var colors = (data.sizesAvail[clamped.size] || []).map(heColor);
      if (!colors.length) {
        lines.push("<div class=\"boe-sc-note\">" + t.outOfStock + "</div>");
      } else if (data.hasColors) {
        lines.push("<div class=\"boe-sc-colors\">" + t.inStock + " " + colors.join(" · ") + "</div>");
      }
      result.innerHTML = lines.join("");
      result.style.display = "";
      calcBtn.style.display = "none";
      retryBtn.style.display = "";
    });

    retryBtn.addEventListener("click", function () {
      result.style.display = "none"; retryBtn.style.display = "none"; calcBtn.style.display = "";
      if (fields.hips) fields.hips.value = ""; if (fields.pants) fields.pants.value = "";
      if (fields.height) fields.height.value = "";
      if (fields.under) fields.under.value = ""; if (fields.cup) fields.cup.value = "";
      if (fields.bust) { fields.bust.value = ""; fields.bust.style.display = "none"; }
      if (fields.tall) fields.tall.checked = false;
    });

    body.appendChild(err); body.appendChild(result); body.appendChild(calcBtn); body.appendChild(retryBtn);
  }

  function openModal(root) {
    var data = getData(root);
    if (!data) return;
    // הטמעת ה-snippet יושבת בתוך <safe-sticky class="product-info"> שמגדירה z-index:1 משלה, וזה
    // פותח סטאקינג-קונטקסט חדש: position:fixed לא בורח ממנו, אז אף z-index על העטיפה לא יעזור
    // נגד רכיבים אחרים בשורש (כמו באנר הקוקיז של שופיפיי, z-index 2000000). גילוי 29/09/2026 -
    // פתרון: מעבירים את המודל עצמו לילד ישיר של body ברגע שהוא נפתח, פעם אחת מספיקה.
    if (root.parentElement !== document.body) document.body.appendChild(root);
    if (!root.dataset.boeScBuilt) { buildForm(root, data); root.dataset.boeScBuilt = "1"; }
    root.classList.add("boe-sc-open");
    document.documentElement.classList.add("boe-sc-lock");
    var video = root.querySelector("video");
    if (video) { video.muted = true; video.play().catch(function () {}); }
    var closeBtn = root.querySelector("[data-boe-sc-close]");
    if (closeBtn) closeBtn.focus();
  }

  function closeModal(root) {
    root.classList.remove("boe-sc-open");
    document.documentElement.classList.remove("boe-sc-lock");
    var video = root.querySelector("video");
    if (video) video.pause();
  }

  function modalFor(productId) {
    return document.getElementById("boe-sc-" + productId) || document.querySelector("[data-boe-sc-modal]");
  }

  document.addEventListener("click", function (e) {
    var opener = e.target.closest("[data-boe-sc-open]");
    if (opener) {
      e.preventDefault();
      var root = modalFor(opener.getAttribute("data-boe-sc-open"));
      if (root) openModal(root);
      return;
    }
    var closer = e.target.closest("[data-boe-sc-close]");
    if (closer) { closeModal(closer.closest("[data-boe-sc-modal]")); return; }
    var overlay = e.target.closest("[data-boe-sc-overlay]");
    if (overlay && e.target === overlay) closeModal(overlay.closest("[data-boe-sc-modal]"));
  });

  document.addEventListener("keydown", function (e) {
    if (e.key !== "Escape") return;
    var open = document.querySelector("[data-boe-sc-modal].boe-sc-open");
    if (open) closeModal(open);
  });

  // תאימות לאחור: ההודעה שהכפתור הישן שלח (וכל מי שעוד שולח אותה)
  window.addEventListener("message", function (event) {
    var d = event && event.data;
    if (!d || d.type !== "OPEN_WIDGET") return;
    var root = modalFor(d.productId);
    if (root) openModal(root);
  });
})();
